import React, { useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Layout,
  Button,
  Row,
  Col,
  Typography,
  Form,
  Input,
  Switch,
  Modal,
  Select,
  Checkbox,
} from "antd";
import signinLogo from "../../assets/images/logo.svg";
import signinbg from "../../assets/images/sign-in-bg.svg";
import MailIcon from "../../assets/images/input-icons/mail-icon.svg";
import UserIcon from "../../assets/images/input-icons/user-icon.svg";
import PasswordIcon from "../../assets/images/input-icons/lock-icon.svg";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import { AuthContext } from "../../context/AuthContext";
import Loader from "../../components/Loader";
import apiPath from "../../constants/apiPath";
import encryptDecrypt from "../../helper/encryptDecrypt";

import Footer from "../../components/layout/Footer";
import Container from "react-bootstrap/Container";
const { Title } = Typography;
const { Content } = Layout;

const Register = () => {
  const { setIsLoggedIn, setUserProfile } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const { request } = useRequest();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  // const [form] = Form.useForm();
  const [rememberMe, setRememberMe] = useState(false);


  const onFinish = (values) => {
    onSubmit(values);
  };

  const onSubmit = (values) => {
    const { email, password, name } = values;

    if (!email)
      return ShowToast("Please enter email to sign in", Severty.ERROR);

    const payload = { password };
    if (!email) return ShowToast("Please enter valid email ", Severty.ERROR);

    console.log(payload, "fkjdhkd");

    setLoading(true);
    payload.email = email;
    payload.name = name;
    payload.password = password;
    payload.loginType = "Email";
    payload.type = "User";
    request({
      url: apiPath.register,
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        console.log(data, "fghdjh data");
        if (data.status) {
          setIsLoggedIn(true);


          ShowToast(data.message, Severty.SUCCESS);
          form.resetFields()
          // setUserProfile(data.data);
          setTimeout(() => navigate("/otp-verification", { state: { email: email } }), 200);

        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const validatePassword = (_, value) => {
    // Basic password validation - at least 8 characters
    if (value && value.length < 8) {
      return Promise.reject(new Error("Password must be at least 8 characters"));
    }
    return Promise.resolve();
  };


  return (
    <>
      <Layout className="layout-default layout-signin">
        <Container>
          <Content className="signin">
            <div className="signup-logo-header">
              <img src={signinLogo} alt="" />
            </div>
            <Row>
              <Col span={24} lg={12} className="contant-bg-sign">
                <div className="signin-box">
                  <Row justify="space-around">
                    <Col xs={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }}>
                      <div className="signup-form">
                        <Title className="mb-15">Sign up to Salla Chat</Title>

                        <Form
                          form={form}
                          onFinish={onFinish}
                          onFinishFailed={onFinishFailed}
                          layout="vertical"
                          className="row-col"
                        >
                          <Form.Item
                            className="username"
                            label="Enter your full name"
                            name="name"
                            rules={[
                              // {
                              //   type: "email",
                              //   message: "Please enter afull name",
                              // },
                              {
                                max: 255,
                                message:
                                  "full name not more then 255 characters!",
                              },
                              {
                                required: true,
                                message: "Please enter your full name!",
                              },
                            ]}
                          >
                            <Input
                              prefix={<img src={UserIcon} />}
                              placeholder="Enter Full Name"
                            />
                          </Form.Item>
                          <Form.Item
                            className="username"
                            label="Enter your email id"
                            name="email"
                            rules={[
                              {
                                type: "email",
                                message: "Please enter a valid email address!",
                              },
                              {
                                max: 255,
                                message:
                                  "Email address not more then 255 characters!",
                              },
                              {
                                required: true,
                                message: "Please enter your email!",
                              },
                            ]}
                          >
                            <Input
                              prefix={<img src={MailIcon} />}
                              placeholder="Enter your email ID"
                            />
                          </Form.Item>
                          <Form.Item
                            className="password"
                            label="Password"
                            name="password"
                            rules={[
                              {
                                min: 8,
                                message: "Password must be at least 8 characters long",
                              },
                              {
                                max: 16,
                                message: "Password cannot exceed 16 characters",
                              },
                              {
                                required: true,
                                message: "Please enter your password!",
                              },
                              {
                                pattern: new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$/),
                                message: "Password must contain at least one uppercase, one lowercase, one number, and one special character!",
                              },
                              // { validator: validatePassword }
                            ]}
                          >
                            <Input.Password
                              prefix={<img src={PasswordIcon} />}
                              onCut={(e) => e.preventDefault()}
                              onCopy={(e) => e.preventDefault()}
                              onPaste={(e) => e.preventDefault()}
                              autoComplete="off"
                              placeholder="Enter Password"
                            />
                          </Form.Item>
                          <Form.Item
                            className="password"
                            label="Confirm Password"
                            name="confirm_password"
                            rules={[
                              { required: true, message: "Please confirm your password" },
                              {
                                pattern: new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$/),
                                message: "Password must contain at least one uppercase, one lowercase, one number, and one special character!",
                              },
                              ({ getFieldValue }) => ({
                                validator(_, value) {
                                  if (!value || getFieldValue('password') === value) {
                                    return Promise.resolve();
                                  }
                                  return Promise.reject(new Error('The passwords and confirm password do not match'));
                                },
                              }),
                            ]}
                          >
                            <Input.Password
                              prefix={<img src={PasswordIcon} />}
                              onCut={(e) => e.preventDefault()}
                              onCopy={(e) => e.preventDefault()}
                              onPaste={(e) => e.preventDefault()}
                              autoComplete="off"
                              placeholder="Enter password"
                            />
                          </Form.Item>
                          <div className="forgot-pass">
                            <Form.Item
                              name="agree"
                              className="aligin-center"
                              valuePropName="checked"
                              rules={[
                                {
                                  validator: (_, value) =>
                                    value
                                      ? Promise.resolve()
                                      : Promise.reject(new Error("You must agree to the Terms & Conditions")),
                                },
                              ]}
                            >
                              <Checkbox className="rem-check">
                                Agree with <Link>Terms & Conditions</Link>
                              </Checkbox>
                            </Form.Item>
                          </div>
                          <Form.Item className="mt-4">
                            <Button
                              className="float-right"
                              type="primary"
                              htmlType="submit"
                              loading={loading}
                            // onClick={() => navigate("/otp-verification")}
                            >
                              Continue
                            </Button>
                          </Form.Item>
                          <div className="outer-sign-page">
                            Already have an account?{" "}
                            <Link to={"/sign-in"}>Sign In</Link>
                          </div>
                        </Form>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col span={24} lg={12} className="signin-bg d-none d-lg-block">
                <div className="signin_img">
                  <img src={signinbg} />
                </div>
              </Col>
            </Row>
          </Content>
        </Container>
        <Footer />
      </Layout>
    </>
  );
};

export default Register;
